import { getImageUrl } from '@src/utils/media-data';
import OptionalImage from '@src/components/optional-image';
import * as React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import Link from '@src/components/link';
import $$tracker from '@src/tracker';
const styles = require('./index.less');

/** 首屏信息 */
const KV = ({ store, onGiftRuleClick }) => {
  store.use();
  const mainStore = store.mainStore || {};
  const kvImg = getImageUrl(store.kvImg);

  const kvButtons = (
    <div className={styles.kvButtons}>
      <Link className={cx(styles.kvButton, styles.btnRecharge)} href={mainStore.chargeUrl} onClick={$$tracker.clickOfficialRecharge} title="充值" />
      <Link className={cx(styles.kvButton, styles.btnDownload)} href={mainStore.downloadUrl} onClick={$$tracker.clickDownloadGame} title="下载" />
    </div>
  );
  // 预约阶段
  const renderReservationStage = () => (
    <React.Fragment>
      <p className={cx(styles.orderStageText)}>
        全网已有<span className={styles.orderCount}>{store.orderCount}</span>人预约
      </p>
      <Link
        className={cx(styles.kvButton, styles.orderButton, { [styles.orderButtonActive]: mainStore?.projectConfig?.phone })}
        onClick={store?.onReservation}
        data-name="立即预约"
      />
      <div className={styles.orderReward} />
    </React.Fragment>
  );

  // 预下载阶段
  const renderPreDownloadStage = () => (
    <React.Fragment>
      <p className={cx(styles.orderStageText)}>
        全网已有<span className={styles.orderCount}>{store.orderCount}</span>人预约
      </p>
      {kvButtons}
    </React.Fragment>
  );

  // 公测阶段
  const renderPublicTestStage = () => kvButtons;

  /** 渲染不同的阶段 */
  const stageRenderByStatus = () => {
    if (mainStore.game_stage_config === 'appointment') return renderReservationStage();
    else if (mainStore.game_stage_config === 'pre_download') return renderPreDownloadStage();
    else if (mainStore.game_stage_config === 'beta_download') return renderPublicTestStage();
  };

  return (
    <div className={styles.kvRoot} style={{ backgroundImage: kvImg ? `url(${kvImg})` : undefined }}>
      <button
        type="button"
        className={styles.giftRuleEntry}
        onClick={onGiftRuleClick}
        aria-label="查看上线瓜分50万现金红包活动规则"
        data-name="上线瓜分50万现金红包"
      />
      <Link className={styles.iconQuery} onClick={store.openQueryLink} data-name="资格查询" />
      <div className={styles.user_info} data-name="用户信息">
        {mainStore?.projectConfig?.phone}
        {mainStore?.projectConfig?.phone && (
          <span className={styles.logout_btn} onClick={store.onLogout}>
            退出
          </span>
        )}
      </div>
      <div className={cx(styles.kvStage, styles[`kvStage-${mainStore.game_stage_config}`])}>{stageRenderByStatus()}</div>
      <div className={styles.kvModule}>
        <div className={styles.ageAppropriateTips}>
          <AgeAppropriateTips gameName={'剑侠世界4'} />
        </div>
        <Link className={styles.videoBox} onClick={store.openVideoModal}>
          {store.kvData?.play_bg_img && <OptionalImage src={store.kvData?.play_bg_img} alt="video" />}
        </Link>
        <span className={styles.scrollDownTip} data-name="向下滚动提示" />
      </div>
    </div>
  );
};

export default observer(KV);
